

function initialState() {
    return {
        multi_service: true,
        visible: true
    }
}

const dev = {
    state: initialState,
    mutations: {
        setMultiService(state, value) {
            state.multi_service = value;
        },
        setVisible(state, value) {
            state.visible = value;
        },
    },
}

export default dev;